import * as React from 'react';
import { Sidebar as SidebarStyled } from '@app/src/components/Sidebar';
import { getConfigsEnabled } from '@app/src/utils/validations';
import { Items } from './types/Items';
import { VIEW } from './constants';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

interface Props {
  history: any;
  resetViewCipGeneration: Function;
  resetViewCipReport: Function;
  logout: Function;
}

export const Sidebar: React.FC<Props> = ({
  history,
  resetViewCipGeneration,
  resetViewCipReport,
  logout
}) => {

  const enabled: boolean = true;
  const isAdmin: boolean = decodeAccessToken('isAdmin');
  const serviceName: string = decodeAccessToken('service');
  const currentView: string = history.location.pathname;

  const getViewCipGeneration = () => {
    history.push(VIEW.CIP_GENERATION);
    resetViewCipReport();
  };

  const getViewCipReport = () => {
    history.push(VIEW.CIP_REPORT);
    resetViewCipGeneration();
  };

  const getViewUsers = () => {
    history.push(VIEW.USERS);
    resetViewCipGeneration();
    resetViewCipReport();
  };

  const isSelectedView = (currentView: string, view: string): boolean => {
    return currentView === view;
  };

  const itemsTop: Items[] = [
    {
      icon: {
        name: 'plus'
      },
      tooltip: 'Generador CIP',
      onClick: getViewCipGeneration,
      selected: isSelectedView(currentView, VIEW.CIP_GENERATION),
      enabled
    },
    {
      icon: {
        name: 'book-open'
      },
      tooltip: 'Reportes',
      onClick: getViewCipReport,
      selected: isSelectedView(currentView, VIEW.CIP_REPORT),
      enabled
    }
  ];

  const itemsBottom: Items[] = [
    isAdmin && {
      icon: {
        name: 'user'
      },
      tooltip: 'Usuarios',
      onClick: getViewUsers,
      selected: isSelectedView(currentView, VIEW.USERS) || isSelectedView(currentView, VIEW.CREATE_USER),
      enabled
    },
    {
      icon: {
        name: 'log-out'
      },
      tooltip: 'Salir',
      onClick: () => logout(history),
      enabled: true
    }
  ];

  React.useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'idUser' && !event.newValue) {
        logout(history)
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return(
    <SidebarStyled
      title={`CallCenter / ${serviceName}`}
      itemsTop={getConfigsEnabled(itemsTop)}
      itemsBottom={getConfigsEnabled(itemsBottom)}
      fixed
    />
  );
};
